<template>
  <div>
    <main>
      <banner />
      <Header />
      <div>
        <router-view :key="$route.fullPath"></router-view>
      </div>
      <Footer />
    </main>
  </div>
</template>

<script>
import Banner from "@/components/tour/TourBanner";
import Header from "./Header";
import Footer from "@/components/PdkFooter";
export default {
  name: "Vouchers",
  components: { Banner, Footer, Header },
  computed: {
    // isLoading() {
    //   return this.$store.getters.loading;
    // },
  },
};
</script>
<style scoped>
.pdk-loading-bar {
  position: absolute;
  top: 40px;
  width: 100%;
  z-index: 1000;
}
</style>